import { render, staticRenderFns } from "./ReviewsMeal.vue?vue&type=template&id=7f6ff825&scoped=true"
import script from "./ReviewsMeal.vue?vue&type=script&lang=js"
export * from "./ReviewsMeal.vue?vue&type=script&lang=js"
import style0 from "./ReviewsMeal.vue?vue&type=style&index=0&id=7f6ff825&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6ff825",
  null
  
)

export default component.exports